export interface TutorialHolder {
  address: string;
  name: string;
}

export const FAKE_HOLDERS: TutorialHolder[] = [
  { address: '0xA1B2C3D4E5F60718293a4b5c6d7e8f9001234567', name: 'landlord.eth' },
  { address: '0xB2C3D4E5F607182930A1b5c6d7e8f90012345678', name: 'degen_mike' },
  { address: '0xC3D4E5F60718293041A2b6c7d8e9f00123456789', name: 'ser_whale' },
  { address: '0xD4E5F6071829304152A3b7c8d9e0f0012345678a', name: 'based_chad' },
  { address: '0xE5F607182930415263A4b8c9d0e1f0012345678b', name: 'meme_lord' },
  { address: '0xF60718293041526374A5b9c0d1e2f0012345678c', name: 'alpha_hunter' },
  { address: '0x0718293041526374850Ab6c1d2e3f0012345678d', name: 'onchain_ape' },
  { address: '0x18293041526374859601b7c2d3e4f0012345678e', name: 'ct_enjoyer' },
  { address: '0x2930415263748596071Ac8d3e4f50012345678ef', name: 'grid_player' },
  { address: '0x30415263748596071829bAd4e5f6001234567890', name: 'fee_farmer' },
  { address: '0x415263748596071829300Be5f607001234567891', name: 'seat_king' },
  { address: '0x526374859607182930410Cf6071800123456789a', name: 'takeover_q' },
  { address: '0x637485960718293041520Df70829001234567abc', name: 'hodl_queen' },
  { address: '0x748596071829304152630Ef80930001234567bcd', name: 'base_maxi' },
  { address: '0x859607182930415263740F091041001234567cde', name: 'anon_buyer' },
  { address: '0x960718293041526374851A1a2152001234567def', name: 'smart_money' },
  { address: '0x071829304152637485962B2b3263001234567ef0', name: 'floor_sweep' },
  { address: '0x182930415263748596073C3c4374001234567f01', name: 'rev_share' },
  { address: '0x293041526374859607184D4d5485001234567012', name: 'pvp_enjoyer' },
  { address: '0x304152637485960718295E5e6596001234567123', name: 'coin_sage' },
  { address: '0x415263748596071829305F6f76a7001234567234', name: 'kingmaker' },
  { address: '0x526374859607182930416070817b8001234567345', name: 'recruiter' },
  { address: '0x6374859607182930415271718292c001234567456', name: 'oracle.eth' },
  { address: '0x748596071829304152638282939d3001234567567', name: 'pot.king' },
  { address: '0x859607182930415263749393a4ae5001234567678', name: 'megadroid' },
  { address: '0x9607182930415263748504a4b5bf60012345670789', name: 'soakmode' },
  { address: '0x07182930415263748596015b5c6c701012345678ab', name: 'fortuna' },
  { address: '0x182930415263748596072626d6e7d80123456789ac', name: 'bigbang' },
  { address: '0x29304152637485960718373737f8e9001234567abd', name: 'whale.dao' },
  { address: '0x304152637485960718294848480090f0012345abce', name: 'beacon.eth' },
  { address: '0x4152637485960718295959590101a01001234abcef', name: 'silver.spoon' },
  { address: '0x5263748596071829306a6a6a121b1102345abcdef', name: 'mintking' },
  { address: '0x6374859607182930417b7b7b232c2102234abcdef', name: 'astro.farmer' },
  { address: '0x7485960718293041528c8c8c343d3203023abcdef', name: 'plot.king' },
  { address: '0x859607182930415263499d9d454e4304a04abcdef', name: 'frost' },
  { address: '0x9607182930415263745aaeae565f5405abcabcdef', name: 'stormcall' },
  { address: '0x071829304152637485bbcfcf676a6606abdabcdef', name: 'zenith' },
  { address: '0x182930415263748596cccdcd787b7707abeabcdef', name: 'gusty' },
  { address: '0x29304152637485960dddedde898c8808abfabcdef', name: 'talos' },
  { address: '0x30415263748596071eeeefef9a9d9909ac0abcdef', name: 'dashiell' },
  { address: '0x4152637485960718fffff0f0abaeaa10ac1abcdef', name: 'ticketmaster' },
  { address: '0x52637485960718290000010101bfbb11ac2abcdef', name: 'houseedge' },
  { address: '0x63748596071829301111121212d0cc12ac3abcdef', name: 'fortune' },
  { address: '0x7485960718293041222223232323dd13ac4abcdef', name: 'toadstool' },
  { address: '0x85960718293041523333343434c4ee14ac5abcdef', name: 'truffle.hog' },
  { address: '0x96071829304152634444454545d5ff15ac6abcdef', name: 'gardener' },
  { address: '0x07182930415263745555565656e6001016ac7abcd', name: 'petalpusher' },
  { address: '0x18293041526374856666676767f7011117ac8abce', name: 'apollo.eth' },
  { address: '0x29304152637485967777787878a8122218ac9abcf', name: 'luna.ox' },
  { address: '0x3041526374859607888989898919b3331ad0abcde', name: 'void.walker' },
];
